import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Hourglass, CheckCircle2, XCircle, Heart } from "lucide-react";
import { kidApi } from "../lib/api";
import { catById, timeAgo } from "../lib/constants";
import { Thumb } from "../components/VideoCard";

const STATUS = {
  pending: { label: "Waiting for grown-up", icon: Hourglass, bg: "#FFD23F" },
  approved: { label: "Live!", icon: CheckCircle2, bg: "#B8F2C9" },
  rejected: { label: "Needs changes", icon: XCircle, bg: "#FF8FC7" },
};

export default function MyVideos() {
  const [videos, setVideos] = useState(null);
  useEffect(() => { kidApi.get("/kid/videos/mine").then((r) => setVideos(r.data)).catch(() => setVideos([])); }, []);

  return (
    <div>
      <h1 className="text-3xl sm:text-5xl font-bold mb-2">My Videos</h1>
      <p className="text-sm sm:text-base text-[#1B1A2E]/70 mb-6 sm:mb-10">Everything you've made. New videos go live once a grown-up says yes.</p>
      {videos?.length === 0 && (
        <div data-testid="my-videos-empty" className="zn-card p-10 text-center">
          <p className="font-display text-2xl mb-5">You haven't made any videos yet.</p>
          <Link to="/kid/studio" data-testid="my-videos-create-btn" className="zn-btn bg-[#FF6B4A] text-white">Make my first video</Link>
        </div>
      )}
      <div className="space-y-3 sm:space-y-5" data-testid="my-videos-list">
        {videos?.map((v, i) => {
          const s = STATUS[v.status];
          const cat = catById(v.category);
          const Icon = cat.icon;
          return (
            <div key={v.id} data-testid={`my-video-${v.id}`} className="zn-card zn-pop p-3 sm:p-5 flex flex-row gap-3 sm:gap-5 items-center" style={{ animationDelay: `${Math.min(i, 8) * 50}ms` }}>
              <Link to={`/kid/watch/${v.id}`} className="relative overflow-hidden w-20 sm:w-40 shrink-0 aspect-[4/5] sm:aspect-video rounded-xl sm:rounded-2xl border-[3px] border-[#1B1A2E] grid place-items-center zn-dots" style={{ backgroundColor: cat.color }}><Icon className="w-7 h-7 sm:w-9 sm:h-9" />{v.thumb && <Thumb id={v.id} title={v.title} />}</Link>
              <div className="flex-1 min-w-0 space-y-1.5">
                <Link to={`/kid/watch/${v.id}`} className="block font-display text-lg sm:text-2xl font-semibold leading-tight truncate hover:underline">{v.title}</Link>
                <p className="text-xs sm:text-sm text-[#1B1A2E]/60">{cat.label} · {timeAgo(v.created_at)} · <Heart size={12} className="inline" /> {v.cheers?.length || 0}</p>
                <span data-testid={`status-pill-${v.id}`} className="zn-chip !py-1 !px-3 !min-h-0 text-xs sm:hidden" style={{ background: s.bg }}><s.icon size={14} /> {s.label}</span>
                {v.status === "rejected" && v.review_note && <p data-testid={`review-note-${v.id}`} className="text-sm bg-[#FFF7EC] rounded-xl px-3 py-2 border-2 border-[#1B1A2E]">Grown-up says: {v.review_note}</p>}
              </div>
              <span className="zn-chip shrink-0 hidden sm:inline-flex" style={{ background: s.bg }}><s.icon size={16} /> {s.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
